// Default adapter when no analytics provider is configured. Silently swallows
// every call so the rest of the codebase can call `analytics.track(...)`
// unconditionally without runtime errors or null checks.
const NoopAdapter = {
  name: 'noop',
  init() {},
  identify() {},
  track() {},
  reset() {},
};

export default NoopAdapter;
